import { injectable } from 'inversify';
import { observable } from 'mobx';

@injectable()
export class FormStore {

    @observable errors = [];
    @observable data: any = {};
    @observable isProcessing = false;

}
